import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../core/Error.js";
import { createDeferred as e } from "../core/promiseUtils.js";
import { beforeLocaleChange as n, getLocale as r } from "./locale.js";
var s = /^([a-z]{2})(?:[-_]([A-Za-z]{2}))?$/,
    o = {
  ar: !0,
  bg: !0,
  bs: !0,
  ca: !0,
  cs: !0,
  da: !0,
  de: !0,
  el: !0,
  en: !0,
  es: !0,
  et: !0,
  fi: !0,
  fr: !0,
  he: !0,
  hr: !0,
  hu: !0,
  id: !0,
  it: !0,
  ja: !0,
  ko: !0,
  lt: !0,
  lv: !0,
  nb: !0,
  nl: !0,
  pl: !0,
  "pt-BR": !0,
  "pt-PT": !0,
  ro: !0,
  ru: !0,
  sk: !0,
  sl: !0,
  sr: !0,
  sv: !0,
  th: !0,
  tr: !0,
  uk: !0,
  vi: !0,
  "zh-CN": !0,
  "zh-HK": !0,
  "zh-TW": !0
};

function i(t) {
  var e;
  return null != (e = o[t]) && e;
}

var a = [],
    c = new Map();

function d(t) {
  var _iterator = _createForOfIteratorHelper(c.keys()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      m(t.pattern, _e) && c.delete(_e);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function l(t) {
  return a.includes(t) || (d(t), a.unshift(t)), {
    remove: function remove() {
      var e = a.indexOf(t);
      e > -1 && (a.splice(e, 1), d(t));
    }
  };
}

function u(_x) {
  return _u.apply(this, arguments);
}

function _u() {
  _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
    var e, n;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            e = r();
            c.has(t) || c.set(t, f(t, e));
            n = c.get(t);
            _context2.next = 5;
            return _.add(n);

          case 5:
            return _context2.abrupt("return", n);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _u.apply(this, arguments);
}

function h(t) {
  if (!s.test(t)) return null;

  var _s$exec = s.exec(t),
      _s$exec2 = _slicedToArray(_s$exec, 3),
      e = _s$exec2[1],
      n = _s$exec2[2],
      r = e + (n ? "-" + n.toUpperCase() : "");

  return i(r) ? r : i(e) ? e : null;
}

function f(_x2, _x3) {
  return _f.apply(this, arguments);
}

function _f() {
  _f = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, n) {
    var r, _iterator2, _step2, _t;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            r = [];
            _iterator2 = _createForOfIteratorHelper(a);
            _context3.prev = 2;

            _iterator2.s();

          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context3.next = 18;
              break;
            }

            _t = _step2.value;

            if (!m(_t.pattern, e)) {
              _context3.next = 16;
              break;
            }

            _context3.prev = 7;
            _context3.next = 10;
            return _t.fetchMessageBundle(e, n);

          case 10:
            return _context3.abrupt("return", _context3.sent);

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](7);
            r.push(_context3.t0);

          case 16:
            _context3.next = 4;
            break;

          case 18:
            _context3.next = 23;
            break;

          case 20:
            _context3.prev = 20;
            _context3.t1 = _context3["catch"](2);

            _iterator2.e(_context3.t1);

          case 23:
            _context3.prev = 23;

            _iterator2.f();

            return _context3.finish(23);

          case 26:
            if (!r.length) {
              _context3.next = 28;
              break;
            }

            throw new t("intl:message-bundle-error", "Errors occurred while loading \"".concat(e, "\""), {
              errors: r
            });

          case 28:
            throw new t("intl:no-message-bundle-loader", "No loader found for message bundle \"".concat(e, "\""));

          case 29:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 20, 23, 26], [7, 13]]);
  }));
  return _f.apply(this, arguments);
}

function m(t, e) {
  return "string" == typeof t ? e.startsWith(t) : t.test(e);
}

n(function () {
  c.clear();
});

var _ = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this._numLoading = 0;
  }

  _createClass(_class, [{
    key: "waitForAll",
    value: function () {
      var _waitForAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this._dfd;

                if (!_context.t0) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this._dfd.promise;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function waitForAll() {
        return _waitForAll.apply(this, arguments);
      }

      return waitForAll;
    }()
  }, {
    key: "add",
    value: function add(t) {
      var _this = this;

      return this._increase(), t.then(function () {
        return _this._decrease();
      }, function () {
        return _this._decrease();
      }), this.waitForAll();
    }
  }, {
    key: "_increase",
    value: function _increase() {
      this._numLoading++, this._dfd || (this._dfd = e());
    }
  }, {
    key: "_decrease",
    value: function _decrease() {
      this._numLoading = Math.max(this._numLoading - 1, 0), this._dfd && 0 === this._numLoading && (this._dfd.resolve(), this._dfd = null);
    }
  }]);

  return _class;
}())(),
    p = {
  cache: c,
  loaders: a
};

export { u as fetchMessageBundle, h as normalizeMessageBundleLocale, l as registerMessageBundleLoader, p as test };